import { useState } from "react";
import useRead from "./useRead";

// Status display helper
export const getStatusDisplay = (status) => {
  switch (status) {
    case "APPROVAL_AWAITING":
      return {
        text: "Approval Awaiting",
        className: "bg-yellow-200 text-yellow-900 px-3 py-1 rounded text-xs",
      };
    case "REVIEWED":
      return {
        text: "Reviewed",
        className: "bg-green-200 text-green-900 px-3 py-1 rounded text-xs",
      };
    case "REJECTED":
      return {
        text: "Rejected",
        className: "bg-red-200 text-red-900 px-3 py-1 rounded text-xs",
      };
    default:
      return {
        text: "No Status",
        className: "px-3 py-1 rounded text-xs",
      };
  }
};

export const useApprovalsApi = () => {
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // Fetch financial years list
  const { list: financialYearsList } = useRead({
    url: "tds/financial-year/list",
    initialData: {
      page_number: 0,
      limit: 100,
    },
    method: "GET",
    onSuccess: (res) => {
      const years = res?.data || [];
      const defaultFY = years.find((fy) => fy.active === "1" || fy.active === 1) || years[0];
      if (defaultFY) {
        setSelectedFinancialYear(defaultFY);
        setEmployeeParams({
          limit: 100,
          page_number: 0,
          financial_year_id: defaultFY.financial_year_id,
        });
      }
    },
  });

  // Fetch employee submissions based on selected financial year
  const { list: employeeSubmissions, setGetListParams: setEmployeeParams } = useRead({
    url: "tds/list-employee-submissions",
    initialData: {
      limit: 100,
      page_number: 0,
    },
    method: "GET",
    enabled: !!selectedFinancialYear?.financial_year_id,
  });

  // Transform financial years for dropdown
  const financialYearOptions =
    financialYearsList?.data?.data?.map((fy) => ({
      financial_year_id: fy.financial_year_id,
      label: fy.label,
      value: fy.financial_year_id,
    })) || [];

  // Transform employee submissions for display
  const employeeOptions =
    employeeSubmissions?.data?.data?.map((emp) => ({
      company_employee_id: emp.company_employee_id,
      employee_tds_submission_id: emp.employee_tds_submission_id,
      name: `${emp.first_name || ""} ${emp.last_name || ""}`.trim() || emp.name || "Unnamed Employee",
      regime: emp.regime,
      created_at: emp.created_at,
      status: emp.status,
    })) || [];

  // Handle financial year change
  const handleFinancialYearChange = (newFinancialYear) => {
    setSelectedFinancialYear(newFinancialYear);
    setSelectedEmployee(null);
    setEmployeeParams({
      limit: 100,
      page_number: 0,
      financial_year_id: newFinancialYear.financial_year_id,
    });
  };

  // Handle employee selection
  const handleEmployeeSelection = (employee) => {
    setSelectedEmployee(employee);
  };

  return {
    financialYearsList,
    financialYearOptions,
    selectedFinancialYear,
    handleFinancialYearChange,
    employeeSubmissions,
    employeeOptions,
    selectedEmployee,
    handleEmployeeSelection,
    isLoadingFinancialYears: financialYearsList?.isLoading,
    isLoadingEmployees: !!selectedFinancialYear?.financial_year_id && employeeSubmissions?.isLoading && !employeeSubmissions?.data,
    getStatusDisplay,
  };
};

export default useApprovalsApi;
